<template src="./VehicleSpeedLimit.html"></template>
<script>
import { orderBy } from "@progress/kendo-data-query";
import CommandCell from "@/components/CommandCellTemplate/CommandCellEditTemplate";
import { createNamespacedHelpers } from "vuex";
const { mapState, mapActions, mapGetters } = createNamespacedHelpers("settings");
import { DEFAULT_SPEED_LIMIT_COLORS, MESSAGES, VEHICLE_SPEED_LIMIT } from "@/utils/constants";
import { notify, notifyApiError } from "@/utils/notification-helper";
import DialogBox from "@/components/DialogBox";
import ViewDropdown from "@/components/ViewDropdown";
import { saveExcel } from "@progress/kendo-vue-excel-export";
import VSwatches from "vue-swatches";
 import VehicleIconTemplate from "./VehicleIconTemplate";
// import moment from "moment-timezone";
import router from '@/router/index';
export default {
  components: {
    DialogBox,
    ViewDropdown,
    VSwatches,
  },
  data: function () {
    return {
      gridHeight: window.innerHeight - 150,
      // addoredit: false,
      gridData: [],
      skip: 0,
      take: 25,
      pageSize: 25,
      pageable: {
        previousNext: true,
        pageSizes: [5, 10, 25, 100, 500],
        pageSize: 10,
      },
      defaultVal: { name: "All", id: "All" },
      searchText: "",
      add: true,
      sort: [{ field: "vehicleRtoNum", dir: "asc" }],
      viewColumns: [],
      columns: [
        {
          hidden: false,
          field: "serialNo",
          title: "S.No",
          width: "90px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
       
          title: "Type",
          cell:VehicleIconTemplate,
          width: "100px",
          checked: true,
          defaultSelected: true,
        },
        {
          hidden: false,
          title: "Safe (<)",
          field: "safeSpeed",
          checked: true,
          width: "160px",
          defaultSelected: false,
          // headerCell: 'headerTemplate'
        },
        {
          hidden: false,
          title: "Moderate",
          field: "safeSpeed",
          checked: true,
          width: "160px",
          defaultSelected: false,
          cell: this.cellFunction
        },
        {
          hidden: false,
          title: "High(>)",
          field: "highSpeed",
          checked: true,
          width: "160px",
          defaultSelected: false,
        },

        {
          hidden: false,
          cell: CommandCell,
          title: "Actions",
          width: "150px",
          locked: true,
          ignoreCheckbox: true,
        },
      ],
      dataItems: [],
      allowVendor: false,
      safespeed: null,
      //  defaultVal: { name: 'All', id: 'all'},
    };
  },
  props: {
    selectedVehicleColumns: Array,
  },
  methods: {
    cellFunction: function (h, tdElement, props) {
      const field = props.field;
      return h("td", {}, `${props.dataItem[field]} - ${props.dataItem['highSpeed']}`);
    },
    openWindow: function () {
      this.$router.push({ name: "vehicle-speed-limit-add", params: { } });
      // this.$router.push("/vehicle-management/add");
    },
    sortChangeHandler: function (e) {
      this.sort = e.sort;
    },

    pageChangeHandler: function (event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    showAdd: function () {
      this.add = true;
    },
    remove: function (item) {
      this.dataItems = item;
      this.$refs.form.openWindow();
    },
    exportExcel() {
      saveExcel({
        data: this.vehicleData,
        fileName: "vehicle",
        columns: this.columns,
      });
    },
    downloadTemplate() {
      saveExcel({
        data: [],
        fileName: "sampleTemplate",
        columns: this.columns,
      });
    },
    OkMethod() {
      let item = this.dataItems;
      return this.$store
        .dispatch("settings/removeSpeedLimit", item.dataItem.id)
        .then(() => {
          notify(MESSAGES.DELETE_SUCCESS);
          // this.getDataOnload();
        })
        .catch(notifyApiError);
    },
    edit: function (item) {
      router.push({ name: "vehicle-speed-limit-add", params: { ...item,  update: true, } });
    },
    async getDataOnload() {
    },
    columnChange(e) {
      if (e.item.checked) {
        e.item.hidden = false;
      } else {
        e.item.hidden = true;
      }
      this.$store.commit("settings/setVehicleSpeedLimitColumns", [
        ...this.columns,
      ]);
      localStorage.setItem(
        "vehicleManagementColumns",
        JSON.stringify(this.viewColumns)
      );
    },
    ...mapActions(["changeSpeedLimitColor"]),
    Search() {
      console.log(this.items);
      this.vehicleData = [];
    },
  },
  computed: {
    ...mapState({
      vehicleData: (state) => state.vehicleData,
      loader: (state) => state.loader
    }),
    ...mapGetters([
      "getSpeedLimit",
      "getVehicleSafeSpeedLimitColor",
      "getVehicleHighSpeedLimitColor",
      "getVehicleModerateSpeedLimitColor",
    ]),
    total() {
      return this.$store.getters['settings/getSpeedLimit'].length;
    },
    filter() {
      return {
        logic: "or",
        filters: [
          {
            field: "highSpeed",
            operator: "contains",
            value: this.searchText,
          },
          {
            field: "safeSpeed ",
            operator: "contains",
            value: this.searchText,
          },
          { field: "model ", operator: "contains", value: this.searchText },
        ],
      };
    },
    vehicleDataVal() {
      return this.$store.getters['settings/getSpeedLimit'];
    },
    safeSpeedColor: {
      get () {
        return this.getVehicleSafeSpeedLimitColor ? this.getVehicleSafeSpeedLimitColor.value : DEFAULT_SPEED_LIMIT_COLORS.SAFE_SPEED;
      },
      set (colorCode) {
        this.changeSpeedLimitColor({ value: colorCode, key: VEHICLE_SPEED_LIMIT.SAFE_SPEED });
      }
    },
    moderateSpeedColor: {
      get () {
        return this.getVehicleModerateSpeedLimitColor ? this.getVehicleModerateSpeedLimitColor.value : DEFAULT_SPEED_LIMIT_COLORS.MODERATE_SPEED
      },
      set (colorCode) {
        this.changeSpeedLimitColor({ value: colorCode, key: VEHICLE_SPEED_LIMIT.MODERATE_SPEED });
      }
    },
    highSpeedColor: {
      get () {
        return this.getVehicleHighSpeedLimitColor ? this.getVehicleHighSpeedLimitColor.value : DEFAULT_SPEED_LIMIT_COLORS.HIGH_SPEED;
      },
      set (colorCode) {
        this.changeSpeedLimitColor({ value: colorCode, key: VEHICLE_SPEED_LIMIT.HIGH_SPEED });
      }
    },
    items: {
      get: function () {
        // TODO getteres wont update with latest Value.
        // console.log("#Speed #2",this.$store.state.speedLimit, this.getSpeedLimit);
        const speedLimit = this.$store.state.speedLimit.map((sl, index) => ({...sl, serialNo: index + 1 }));
        return orderBy(
          speedLimit.filter(
            (sl) =>
              (
                (sl.vehicleType ? sl.vehicleType.type : '')
                + sl.highSpeed + " "
                + sl.safeSpeed + " "
              ).includes(this.searchText)
          ).slice(this.skip, this.take + this.skip),
          this.sort
        );
      },
    },
  },
  mounted() {
    this.getDataOnload();

    const eListColumns = JSON.parse(
      localStorage.getItem("vehicleManagementColumns")
    );
    if (!eListColumns) {
      this.viewColumns = [...this.columns];
      this.$store.commit("vehicle/setSelectedVehicleColumns", [
        ...this.columns,
      ]);
    } else {
      let items = [];
      this.columns.map((col, i) => {
        const obj = eListColumns.find((c) => c.field === col.field);
        // Ignoring last column
        if (i < this.columns.length - 1)
          if (obj) {
            items.push({
              ...col,
              hidden: obj.hidden,
              checked: obj.checked,
              defaultSelected: obj.defaultSelected,
              ignoreCheckbox: obj.ignoreCheckbox,
            });
          } else {
            items.push({ ...col });
          }
      });

      // adding ignored last column
      items.push(this.columns[this.columns.length - 1]);
      this.viewColumns = items;
      this.columns = items;
      this.$store.commit("vehicle/setSelectedVehicleColumns", items);
    }
  },
  created: function () {
    this.unsubscribe = this.$store.subscribe(async (mutation) => {
      if (mutation.type == "setInitialData") {
        this.getDataOnload();
      }
    });
  },
  beforeDestroy() {
    this.unsubscribe();
  },
  beforeMount() {},
};
</script>
<style >
  .form__input { z-index: 1000px; height: 10px; width: 10px;}
  .vue-swatches__trigger { width: 20px; height: 20px;}
  .vue-swatches__swatch { position: relative;}
  .c-swatches { display: flex; justify-content: center;}
  .add_search_mobile{display: flex;}
  .display_header_mbl{display: flex;}
  .search_mobile_s{width: 100% !important; border-radius: 5px;}
  @media only screen and (max-width: 768px) {
    .display_header_mbl{display: block;}
    .search_mobile_s{width: 40% !important;}
    .add_search_mobile{display: flex; justify-content: flex-end;}
  .driver_header_mobile{flex-direction: row !important; padding: 10px 10px 10px 10px;}
  .page-header .title-text {font-size: 12px;} 
  }
</style>